import { useEffect } from 'react';
import useShowInvitationModal from './useShowInvitationModal';

const STORAGE_KEY = 'SHOW_INVITATION_MODAL';

export const setAutoShowInvitationModal = () => {
  sessionStorage.setItem(STORAGE_KEY, 'true');
};

const useAutoShowInvitationModalEffect = () => {
  const showInvitationModal = useShowInvitationModal();

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) {
      sessionStorage.removeItem(STORAGE_KEY);
      showInvitationModal();
    }
  }, [showInvitationModal]);
};

export default useAutoShowInvitationModalEffect;
